module.exports = __webpack_public_path__ + "media/icons/minus-c79880e0.png";